<script setup lang="ts">
/**
 * Каркас приватной части: сайдбар слева, шапка сверху, вью внутри.
 * Смонтирован как компонент маршрута `/`, поэтому переживает навигацию
 * между всеми дочерними экранами — сайдбар не перерисовывается.
 */
import ConfirmDialog from '@/components/common/ConfirmDialog.vue'
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'
import AppHeader from './AppHeader.vue'
import AppSidebar from './AppSidebar.vue'
</script>

<template>
  <SidebarProvider>
    <AppSidebar />

    <SidebarInset>
      <AppHeader />

      <div class="flex flex-1 flex-col gap-6 p-4 md:p-6">
        <RouterView />
      </div>
    </SidebarInset>

    <!--
      Единственный экземпляр промис-диалога на всё приложение (см. `useConfirm.ts`).
      Живёт здесь, а не в `App.vue`: на `/login` подтверждать нечего, а App.vue
      принадлежит F0. Без ровно одного смонтированного `<ConfirmDialog />`
      `await confirm(...)` вернёт промис, который никто никогда не разрешит,
      и обработчик удаления повиснет молча.
    -->
    <ConfirmDialog />
  </SidebarProvider>
</template>
